import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function ClosingSection() {
  return <section className="py-24 px-4 bg-[#0a0e1a] border-t border-[#c9a84c]/10 relative overflow-hidden" data-id="element-1">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-[#c9a84c]/5 rounded-t-full blur-[100px] pointer-events-none" data-id="element-2" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-3">
        <FadeIn data-id="element-4">
          <div className="text-center mb-16" data-id="element-5">
            <h2 className="text-3xl md:text-5xl font-bold text-[#f5f5f5] mb-6" data-id="element-6">
              Tienes dos caminos hoy:
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-7">
          <FadeIn delay={0.1} data-id="element-8">
            <div className="bg-[#111827] border border-gray-800 p-8 rounded-2xl h-full opacity-70 hover:opacity-100 transition-opacity" data-id="element-9">
              <div className="flex items-center gap-4 mb-6" data-id="element-10">
                <XCircleIcon className="w-8 h-8 text-gray-500" data-id="element-11" />
                <h3 className="text-2xl font-bold text-gray-400" data-id="element-12">
                  Camino A: No hacer nada
                </h3>
              </div>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-13">
                Seguir sintiéndote cansado, ver cómo tu barriga crece cada año y
                aceptar que tu vida sexual y profesional decline lentamente.
                Aceptar que "es la edad".
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-14">
            <div className="bg-gradient-to-b from-[#111827] to-[#0a0e1a] border-2 border-[#c9a84c] p-8 rounded-2xl h-full shadow-[0_0_30px_rgba(201,168,76,0.15)] transform md:-translate-y-4" data-id="element-15">
              <div className="flex items-center gap-4 mb-6" data-id="element-16">
                <CheckCircle2Icon className="w-8 h-8 text-[#c9a84c]" data-id="element-17" />
                <h3 className="text-2xl font-bold text-[#f5f5f5]" data-id="element-18">
                  Camino B: Tomar acción
                </h3>
              </div>
              <p className="text-[#f5f5f5] text-lg leading-relaxed" data-id="element-19">
                Descargar Código Alfa 40+, activar tu sistema hormonal y volver
                a ser el hombre que tu familia, tu trabajo y tú mismo merecen
                ser. Recuperar el control.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-20">
          <Button href="https://www.tumomentovital.com/cart/47616565608640:1" onClick={() => {
          if ((window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
        }} className="w-full md:w-auto text-lg md:text-xl px-12 py-6 shadow-[0_0_40px_rgba(201,168,76,0.3)]" data-id="element-21">
            SÍ, QUIERO RECUPERAR MI ENERGÍA — ACCESO INMEDIATO POR $6.36
          </Button>
          <p className="mt-6 text-[#9ca3af] text-sm" data-id="element-22">
            Pago seguro. Acceso instantáneo. Garantía de 7 días.
          </p>
        </FadeIn>
      </div>
    </section>;
}